// extracted by mini-css-extract-plugin
module.exports = {"headline":"Headline_headline__qr-h5","line":"Headline_line__17ADL","eng":"Headline_eng__1XkhF","subtitle":"Headline_subtitle__2tnjp","chinese":"Headline_chinese__2R5Gd"};